/* eslint no-eq-null: 0 */
/* eslint eqeqeq: 0 */
/* tslint:disable:triple-equals */
export default function isWindow(obj) {
    return obj != null && obj == obj.window;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/rmc-align/es/isWindow.js
// module id = 411
// module chunks = 0